import { render, staticRenderFns } from "./twoFactorAuthentication.vue?vue&type=template&id=2884c9fe&scoped=true&"
import script from "./twoFactorAuthentication.vue?vue&type=script&lang=js&"
export * from "./twoFactorAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./twoFactorAuthentication.vue?vue&type=style&index=0&id=2884c9fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2884c9fe",
  null
  
)

export default component.exports